import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  deleteCacheForEventStats,
  fetchCongressesDetails,
  getCacheOldestEntryPeriodForEventStats,
  getEventStatsDataTable,
  getGlobalEventStats,
} from "../../../../actions/thunks/eventStats";
import { setEventDataTableAppTypeFilter } from "../../../../actions/actions/eventStats";
import EventCharts from "../EventCharts";
import EventCardFeetching from "../../../feetching/EventCardFeetching";
import FacturationStatsCard from "./FacturationStatsCard";
import _ from 'i18n';
import { InfoCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { showErrorNotification } from "../../../../services/utils";
import SaisonFilter from "../../../Filters/EventStats/SaisonFilter";

const FacturationStats = ({
  eventStatsFilter,
  eventStatsGlobal,
  auth,
  lng,
  getGlobalEventStats,
  setEventDataTableAppTypeFilter,
  deleteCacheForEventStats,
  getEventStatsDataTable,
  fetchCongressesDetails,
  getCacheOldestEntryPeriodForEventStats
}) => {
  const [appType, setAppType] = useState('global');
  const [color, setColor] = useState('#29394D');
  const [refreshing, setRefreshing] = useState(false);
  const [cacheOldestEntryPeriod, setCacheOldestEntryPeriod] = useState(0);
  const [fetchingCacheOldestEntryPeriod, setFetchingCacheOldestEntryPeriod] = useState(true);
  const [globalStatsError, setGlobalStatsError] = useState(false);

  const handleAppTypeSelect = (appType, color) => {
    setAppType(appType);
    setColor(color);

    if (appType == 'registering' || appType == 'cycle_registering' || appType == 'all_in' || appType == 'congres' || appType == 'cycle_essential')
      setEventDataTableAppTypeFilter([appType]);

  };

  const getEventStats = () => {
    setGlobalStatsError(false);
    let params = {};

    if (eventStatsFilter.year.length > 0) {
      params.year = eventStatsFilter.year;
    }

    if (auth.currentClient) {
      params.issuerId = auth.currentClient.id;
    }
    // was used
    params.startMonth = eventStatsFilter.startMonth;
    params.endMonth = eventStatsFilter.endMonth;


    params.season = isNaN(eventStatsFilter.season) ? eventStatsFilter.season : Number(eventStatsFilter.season);

    getGlobalEventStats(params).then((res) => { }).catch((err) => {
      /*if(err.message.includes("504") || err.message.includes("Network Error")){
        this.setState({globalStatsError: true})
      }*/
      if (err.message != "Operation canceled by the user.") {
        setGlobalStatsError(true);
      }
    });
  }

  const refreshData = () => {
    setRefreshing(true);

    deleteCacheForEventStats().then((res) => {
      setRefreshing(false);
      setCacheOldestEntryPeriod(0);
      getEventStats();
      fetchEventStatsDataTable();

    }
    ).catch((err) => {
      setRefreshing(false);
      showErrorNotification(_('error'), _('errorOccured'));
    }
    );

  }
  // renommer getEventStatsDataTable en fetchEventStatsDataTable pour plus de clarté, et éviter la confusion avec getGlobalEventStats
  const fetchEventStatsDataTable = () => {

    let params = {};

    if (eventStatsFilter.search.trim() !== "") {
      params.search = eventStatsFilter.search;
    }

    if (eventStatsFilter.year.length > 0) {
      params.year = eventStatsFilter.year;
    }

    if (eventStatsFilter.appType.length > 0) {
      params.appType = eventStatsFilter.appType;
    }

    if (auth.currentClient) {
      params.issuerId = auth.currentClient.id;
    }

    params.limit = eventStatsFilter.pageSize;
    params.start = (eventStatsFilter.current - 1) * eventStatsFilter.pageSize;
    params.lang = eventStatsFilter.language;
    params.startMonth = eventStatsFilter.startMonth;
    params.endMonth = eventStatsFilter.endMonth;
    params.season = isNaN(eventStatsFilter.season) ? eventStatsFilter.season : Number(eventStatsFilter.season);
    params.activitiesOrder = eventStatsFilter.activitiesOrder;

    if (eventStatsFilter.appType != 'congres') {
      getEventStatsDataTable(params);
    } else {
      fetchCongressesDetails(params);
    }
  }

  const secondsToHm = (d) => {
    if (d < 60)
      return _('NOW');

    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);

    var hDisplay = h > 0 ? h + "h" : "";
    var mDisplay = m >= 10 ? m + "min" : "0" + m + "min";

    return hDisplay + mDisplay;
  }

  // componentDidMount() => useEffect
  useEffect(() => {
    getEventStats();
    getCacheOldestEntryPeriodForEventStats().then(res => {
      setCacheOldestEntryPeriod(res.data.data.cacheOldestEntryPeriod);
      setFetchingCacheOldestEntryPeriod(false);
    });
  }, []);

  // componentDidUpdate => UseEffect with dependencies
  useEffect(() => {
    getEventStats();
  }, [eventStatsFilter.year,
  eventStatsFilter.startMonth,
  eventStatsFilter.endMonth,
  eventStatsFilter.season]);

  const { fetching, fetched } = eventStatsGlobal;
  const { all_in, cycle, formation, premium, congrès, cycle_essential } = eventStatsGlobal.items;

  let cacheOldestEntryPeriodFormatted = secondsToHm(cacheOldestEntryPeriod);

  //Global card statistics are calculated in the front =( (to-modify)
  // we  get the userIds to calculate the number of persons for the global card
  //Sometimes we get an object of user ids instead of an array, to be sure we do this conversion
  if (formation && formation.hasNotPaidUserIds) {
    formation.hasNotPaidUserIds = Object.values(formation.hasNotPaidUserIds);
    formation.hasPaidUserIds = Object.values(formation.hasPaidUserIds);
    cycle.hasNotPaidUserIds = Object.values(cycle.hasNotPaidUserIds);
    cycle.hasPaidUserIds = Object.values(cycle.hasPaidUserIds);
    all_in.hasNotPaidUserIds = Object.values(all_in.hasNotPaidUserIds);
    all_in.hasPaidUserIds = Object.values(all_in.hasPaidUserIds);
    premium.hasNotPaidUserIds = Object.values(premium.hasNotPaidUserIds);
    premium.hasPaidUserIds = Object.values(premium.hasPaidUserIds);
    congrès.hasNotPaidUserIds = Object.values(congrès.hasNotPaidUserIds);
    congrès.hasPaidUserIds = Object.values(congrès.hasPaidUserIds);
    cycle_essential.hasNotPaidUserIds = Object.values(cycle_essential.hasNotPaidUserIds);
    cycle_essential.hasPaidUserIds = Object.values(cycle_essential.hasPaidUserIds);
  }

  return (
    <div>
      <div className={'flex items-center'} style={{ marginBottom: '18px', justifyContent: 'space-between' }}>
        <div className={'flex items-center'}>
          <div className={'event-stats-section-title mr-2'} style={{ marginBottom: '0' }}>{_('FACTURATIONS')}</div>
          <ReloadOutlined spin={refreshing} style={{ fontSize: '20px', color: '#29394D' }} onClick={() => refreshData()} />
          {
            fetchingCacheOldestEntryPeriod == false &&
            <div className={'data-info ml-2'}
              style={{ marginBottom: '0' }}>{_('LAST_CACHE_UPDATE') + (cacheOldestEntryPeriod < 60 ? cacheOldestEntryPeriodFormatted : (lng == 'fr' ? 'il y a ' + cacheOldestEntryPeriodFormatted : (lng == 'eng' ? cacheOldestEntryPeriodFormatted + ' ago' : cacheOldestEntryPeriodFormatted + ' geleden')))}</div>
          }
        </div>
        <SaisonFilter />
      </div>
      {
        globalStatsError === false ?
          <div className={'flex justify-between'} style={{ justifyContent: auth.currentClient.id == 9 ? '' : 'space-evenly' }}>
            <div style={{ width: '15%', marginRight: "3px" }}>
              {
                fetching ? <EventCardFeetching appType={'global'} /> :
                  <FacturationStatsCard selected={appType === 'global'}
                    appType={'global'}
                    formation={formation && formation}
                    cycle={cycle && cycle}
                    all_in={all_in && all_in}
                    premium={premium && premium}
                    congrès={congrès && congrès}
                    cycle_essential={cycle_essential && cycle_essential}
                    color="#29394D"
                    handleAppTypeSelect={handleAppTypeSelect}

                  />
              }
            </div>
            <div style={{ width: '15%', marginRight: "3px" }}>
              {
                fetching ? <EventCardFeetching appType={'registering'} /> :
                  <FacturationStatsCard selected={appType === 'registering'}
                    appType={'registering'}
                    nbrActivities={formation && formation.nbrActivities}
                    paidRegistrant={formation && formation.paidRegistrant}
                    notpaidRegistrant={formation && formation.hasNotPaidUserIds.length}
                    inDistinctPaidRegistrant={formation && formation.inDistinctPaidRegistrant}
                    inDistinctNotPaidRegistrant={formation && formation.notPaidRegistrant}
                    hasPaidUserIds={formation && formation.hasPaidUserIds}
                    hasNotPaidUserIds={formation && formation.hasNotPaidUserIds}
                    color="#18A0FB"
                    handleAppTypeSelect={handleAppTypeSelect}
                  />
              }
            </div>
            {
              (auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') ? (
                <div style={{ width: '15%', marginRight: "3px" }}>
                  {
                    fetching ? <EventCardFeetching appType={'cycle_registering'} /> :
                      <FacturationStatsCard selected={appType === 'cycle_registering'}
                        appType={'cycle_registering'}
                        nbrActivities={cycle && cycle.nbrActivities}
                        paidRegistrant={cycle && cycle.paidRegistrant}
                        notpaidRegistrant={cycle && cycle.hasNotPaidUserIds.length}
                        inDistinctPaidRegistrant={cycle && cycle.inDistinctPaidRegistrant}
                        inDistinctNotPaidRegistrant={cycle && cycle.notPaidRegistrant}
                        hasPaidUserIds={cycle && cycle.hasPaidUserIds}
                        hasNotPaidUserIds={cycle && cycle.hasNotPaidUserIds}
                        color="#5F5DE8"
                        handleAppTypeSelect={handleAppTypeSelect}
                      />
                  }
                </div>
              ) : null
            }
            {
              auth.currentClient.businessType === 'SUPER_CHAIN' ? (
                <React.Fragment>
                  <div style={{ width: '15%', marginRight: "3px" }}>
                    {
                      fetching ? <EventCardFeetching appType={'all_in'} /> :
                        <FacturationStatsCard selected={appType === 'all_in'}
                          appType={'all_in'}
                          nbrActivities={all_in && all_in.nbrActivities}
                          paidRegistrant={all_in && all_in.paidRegistrant}
                          notpaidRegistrant={all_in && all_in.hasNotPaidUserIds.length}
                          inDistinctPaidRegistrant={all_in && all_in.inDistinctPaidRegistrant}
                          inDistinctNotPaidRegistrant={all_in && all_in.notPaidRegistrant}
                          hasPaidUserIds={all_in && all_in.hasPaidUserIds}
                          hasNotPaidUserIds={all_in && all_in.hasNotPaidUserIds}
                          color="#F47F4D"
                          handleAppTypeSelect={handleAppTypeSelect}
                        />
                    }
                  </div>
                  <div style={{ width: '15%', marginRight: "3px" }}>
                    {
                      fetching ? <EventCardFeetching appType={'premium'} /> :
                        <FacturationStatsCard selected={appType === 'premium'}
                          appType={'premium'}
                          nbrActivities={premium && premium.nbrActivities}
                          paidRegistrant={premium && premium.paidRegistrant}
                          notpaidRegistrant={premium && premium.hasNotPaidUserIds.length}
                          inDistinctPaidRegistrant={premium && premium.inDistinctPaidRegistrant}
                          inDistinctNotPaidRegistrant={premium && premium.notPaidRegistrant}
                          hasPaidUserIds={premium && premium.hasPaidUserIds}
                          hasNotPaidUserIds={premium && premium.hasNotPaidUserIds}
                          color="#FB1E5B"
                          handleAppTypeSelect={handleAppTypeSelect}
                        />
                    }
                  </div>
                  <div style={{ width: '15%', marginRight: "3px" }}>
                    {
                      fetching ? <EventCardFeetching appType={'cycle_essential'} /> :
                        <FacturationStatsCard selected={appType === 'cycle_essential'}
                          appType={'cycle_essential'}
                          nbrActivities={cycle_essential && cycle_essential.nbrActivities}
                          paidRegistrant={cycle_essential && cycle_essential.paidRegistrant}
                          notpaidRegistrant={cycle_essential && cycle_essential.hasNotPaidUserIds.length}
                          inDistinctPaidRegistrant={cycle_essential && cycle_essential.inDistinctPaidRegistrant}
                          inDistinctNotPaidRegistrant={cycle_essential && cycle_essential.notPaidRegistrant}
                          hasPaidUserIds={cycle_essential && cycle_essential.hasPaidUserIds}
                          hasNotPaidUserIds={cycle_essential && cycle_essential.hasNotPaidUserIds}
                          color="#14B7AD"
                          handleAppTypeSelect={handleAppTypeSelect}
                        />
                    }
                  </div>
                  <div style={{ width: '15%' }}>
                    {
                      fetching ? <EventCardFeetching appType={'congrès'} /> :
                        <FacturationStatsCard selected={appType === 'congres'}
                          appType={'congres'}
                          nbrActivities={congrès && congrès.nbrActivities}
                          paidRegistrant={congrès && congrès.paidRegistrant}
                          notpaidRegistrant={congrès && congrès.hasNotPaidUserIds.length}
                          inDistinctPaidRegistrant={congrès && congrès.inDistinctPaidRegistrant}
                          inDistinctNotPaidRegistrant={congrès && congrès.notPaidRegistrant}
                          hasPaidUserIds={congrès && congrès.hasPaidUserIds}
                          hasNotPaidUserIds={congrès && congrès.hasNotPaidUserIds}
                          color="#6D7F92"
                          handleAppTypeSelect={handleAppTypeSelect}
                        />
                    }
                  </div>
                </React.Fragment>
              ) : null
            }
          </div>
          :
          <div className={'flex items-center flex-column justify-center retry-container'} style={{ minHeight: '200px' }}>
            <div className={'retry-label mb-3'}>{_('ERROR_OCCURED')}</div>
            <button type={"button"} className={'retry-button'} onClick={getEventStats}>
              {_('RETRY')}
            </button>
          </div>
      }

      {
        fetched &&
        <div className={'facturation-charts-container event'} style={{ borderColor: color }}>
          <EventCharts event={appType == 'global' ? eventStatsGlobal.items :
            (appType == 'registering' ? formation :
              (appType == 'cycle_registering' ? cycle :
                (appType == 'all_in' ? all_in :
                  (appType == 'premium' ? premium :
                    (appType == "cycle_essential" ? cycle_essential : congrès))
                )
              ))} />
        </div>
      }
    </div>
  );

}


const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventStatsGlobal: state.eventStatsGlobal,
  auth: state.auth,
  lng: state.params.lng,
});



const mapDispatchToProps = {
  getGlobalEventStats,
  setEventDataTableAppTypeFilter,
  deleteCacheForEventStats,
  getEventStatsDataTable,
  fetchCongressesDetails,
  getCacheOldestEntryPeriodForEventStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacturationStats);




// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/Facturation/FacturationStats.js